import React from "react";
import LoginWithEmail from "./LoginWithEmail";

export default (props) => (
  <LoginWithEmail
    userType={2}
    loginBankIdUrl={"/login-bankid"}
    history={props.history}
  />
);